/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateVisitRegistrationDto
 */
export interface CreateUpdateVisitRegistrationDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateVisitRegistrationDto
     */
    firstname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateVisitRegistrationDto
     */
    surname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateVisitRegistrationDto
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateVisitRegistrationDto
     */
    mail?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateVisitRegistrationDto
     */
    visitDateTime?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateVisitRegistrationDto
     */
    visitTime?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateVisitRegistrationDto
     */
    appointmentChannelId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateVisitRegistrationDto
     */
    examTypeId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateVisitRegistrationDto
     */
    examId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateVisitRegistrationDto
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateVisitRegistrationDto
     */
    online?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateVisitRegistrationDto
     */
    invoiceName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateVisitRegistrationDto
     */
    invoiceNip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateVisitRegistrationDto
     */
    invoiceAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateVisitRegistrationDto
     */
    sellDocumentType?: CreateUpdateVisitRegistrationDtoSellDocumentTypeEnum | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateVisitRegistrationDto
     */
    harmfulFactorsIds?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateVisitRegistrationDto
     */
    active?: boolean | null;
}


/**
 * @export
 */
export const CreateUpdateVisitRegistrationDtoSellDocumentTypeEnum = {
    Paragon: 'Paragon',
    Faktura: 'Faktura'
} as const;
export type CreateUpdateVisitRegistrationDtoSellDocumentTypeEnum = typeof CreateUpdateVisitRegistrationDtoSellDocumentTypeEnum[keyof typeof CreateUpdateVisitRegistrationDtoSellDocumentTypeEnum];


/**
 * Check if a given object implements the CreateUpdateVisitRegistrationDto interface.
 */
export function instanceOfCreateUpdateVisitRegistrationDto(value: object): value is CreateUpdateVisitRegistrationDto {
    return true;
}

export function CreateUpdateVisitRegistrationDtoFromJSON(json: any): CreateUpdateVisitRegistrationDto {
    return CreateUpdateVisitRegistrationDtoFromJSONTyped(json, false);
}

export function CreateUpdateVisitRegistrationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateVisitRegistrationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'firstname': json['firstname'] == null ? undefined : json['firstname'],
        'surname': json['surname'] == null ? undefined : json['surname'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'mail': json['mail'] == null ? undefined : json['mail'],
        'visitDateTime': json['visitDateTime'] == null ? undefined : (new Date(json['visitDateTime'])),
        'visitTime': json['visitTime'] == null ? undefined : json['visitTime'],
        'appointmentChannelId': json['appointmentChannelId'] == null ? undefined : json['appointmentChannelId'],
        'examTypeId': json['examTypeId'] == null ? undefined : json['examTypeId'],
        'examId': json['examId'] == null ? undefined : json['examId'],
        'description': json['description'] == null ? undefined : json['description'],
        'online': json['online'] == null ? undefined : json['online'],
        'invoiceName': json['invoiceName'] == null ? undefined : json['invoiceName'],
        'invoiceNip': json['invoiceNip'] == null ? undefined : json['invoiceNip'],
        'invoiceAddress': json['invoiceAddress'] == null ? undefined : json['invoiceAddress'],
        'sellDocumentType': json['sellDocumentType'] == null ? undefined : json['sellDocumentType'],
        'harmfulFactorsIds': json['harmfulFactorsIds'] == null ? undefined : json['harmfulFactorsIds'],
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function CreateUpdateVisitRegistrationDtoToJSON(value?: CreateUpdateVisitRegistrationDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'firstname': value['firstname'],
        'surname': value['surname'],
        'phone': value['phone'],
        'mail': value['mail'],
        'visitDateTime': value['visitDateTime'] == null ? undefined : ((value['visitDateTime'] as any).toISOString()),
        'visitTime': value['visitTime'],
        'appointmentChannelId': value['appointmentChannelId'],
        'examTypeId': value['examTypeId'],
        'examId': value['examId'],
        'description': value['description'],
        'online': value['online'],
        'invoiceName': value['invoiceName'],
        'invoiceNip': value['invoiceNip'],
        'invoiceAddress': value['invoiceAddress'],
        'sellDocumentType': value['sellDocumentType'],
        'harmfulFactorsIds': value['harmfulFactorsIds'],
        'active': value['active'],
    };
}

